import React from 'react'
import { makeStyles } from '@material-ui/core'
import GlueIcon from '../glueos-components/glue-icon'
import CheckIcon from '@material-ui/icons/Check'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative'
  },

  check: {
    position: 'absolute',
    right: `calc(-${theme.custom.icon.width} - ${theme.spacing('m')})`,
    bottom: 0
  },

  icon: {
    color: theme.palette.input.valid
  }
}), { name: 'MuiGlueInputValidator' })

const InputValidator = (props) => {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      {props.children}
      {props.valid && (
        <div className={classes.check}>
          <GlueIcon>
            <CheckIcon className={classes.icon} />
          </GlueIcon>
        </div>
      )}
    </div>
  )
}

export default InputValidator
